import apiClient from "./apiClient";


const industries = {
  'Technology & Digital': [
    'E-commerce', 'SaaS', 'IT Services', 'Cybersecurity',
    'Cloud Infrastructure', 'Digital Marketing', 'AI & ML', 'Blockchain',
  ],
  'Healthcare & Life Sciences': [
    'Healthcare', 'Pharmaceuticals', 'Medical Devices', 'Telemedicine', 'Biotech',
  ],
  'Finance & Insurance': [
    'Banking', 'FinTech', 'Insurance', 'Wealth Management', 'Accounting',
  ],
  'Education & Learning': [
    'EdTech', 'E-Learning', 'K-12 Education', 'Higher Education', 'Corporate Training',
  ],
  'Retail & Consumer': [
    'Retail', 'Fashion & Apparel', 'Food & Beverage', 'Consumer Electronics',
  ],
  'Industrial & Manufacturing': [
    'Manufacturing', 'Automotive', 'Energy', 'Oil & Gas', 'Aerospace',
  ],
  'Logistics & Infrastructure': [
    'Logistics', 'Supply Chain', 'Transportation', 'Real Estate', 'Smart Cities',
  ],
  'Media & Entertainment': [
    'Media', 'Gaming', 'Music', 'OTT Platforms', 'Events',
  ],
  'Others': [
    'Agriculture', 'Travel & Tourism', 'LegalTech', 'HR Tech', '...',
  ],
};


export const getIndustries = async () => {
  try {
    const response = await apiClient.get("/industries");
    return response.data;
  } catch (error) {
      console.error("Error fetching industries:", error);
      //throw error; // rethrow so component can handle it
      return industries;
  }
};
